var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.componentType,_vm._g(_vm._b({tag:"component",model:{value:(_vm.model[_vm.def.name]),callback:function ($$v) {_vm.$set(_vm.model, _vm.def.name, (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"model[def.name]"}},'component',_vm.getAttrs(),false),_vm.getListeners()))
}
var staticRenderFns = []

export { render, staticRenderFns }